<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <md-card class="maintenance-mode">
                <md-card-header class="md-card-header-icon md-card-header-primary">
                    <div class="card-icon">
                        <md-icon>settings</md-icon>
                    </div>
                    <h4 class="title">
                        Maintenance mode
                    </h4>
                </md-card-header>

                <md-card-content>
                    <md-table>
                        <md-table-row>
                            <md-table-head>Platform</md-table-head>
                            <md-table-head>Status</md-table-head>
                            <md-table-head>Description</md-table-head>
                            <md-table-head></md-table-head>
                        </md-table-row>

                        <maintenance-mode-row :is-maintenance-mode="false" :app="'sso'"
                                              :description-prop="'Maintenance mode prevents access to the SSO (and subsequently all 3 platforms)'"/>
                        <template v-for="(value, key) in apps">
                            <maintenance-mode-row :is-maintenance-mode="value" :app="key" :key="key + value"/>
                        </template>
                    </md-table>
                </md-card-content>
            </md-card>

        </div>
    </div>
</template>

<style scoped>

.app-name {
    text-transform: capitalize;
}
</style>

<script>
import {mapMutations} from "vuex";
import MaintenanceModeRow from "@/new/pages/SystemSettings/MaintenanceModeRow";

export default {
    name: "MaintenanceMode",
    components: {MaintenanceModeRow},
    data() {
        return {
            apps:
                {
                    compliance: true,
                    dfs: true,
                    academy: true
                },
        }
    },
    methods: {
        getMaintenanceModeStatus() {
            this.$api.isInMaintenanceMode().then(({data}) => {
                this.apps = data
            })
        },
        ...mapMutations('app', {
            setTitlePage: 'setTitlePage',
        })
    },
    mounted() {
        this.getMaintenanceModeStatus();
        this.setTitlePage(this.$t('Maintenance mode'));
    }
}
</script>